// API host for admin requests; falls back to production if the env var is missing.
const API_HOST = (process.env.REACT_APP_BACKEND_URL || 'https://admin.lalhoopsgenius.com').replace(
  /\/$/,
  ''
);

const baseURL = `${API_HOST}/api`;

export default baseURL;
